/**
 * `modules/action/scrollToTop.js`
 * - 画面上部に戻るボタン
 *
 * 使用方法:
 * - import {scrollToTop} from "modules/action/scrollToTop.js";
 */


import {smoothScroll} from "../../utils/index.js";


export function initScrollTop(button, listeners) {
  const toTop = () => {
    smoothScroll("windowTop");
  };

  button.addEventListener("click", toTop);
  listeners.push([button, "click", toTop]);
}